<template>
    <div>
        <div class="card mb-3 p-3 pt-2">
            <label for="assessment-descr" class="mb-1">Assessment Opportunity or Activity</label>
            <textarea class="form-control" id="assessment-descr" v-model="opportunity" ></textarea>
            <div class="mt-2 d-flex justify-content-end">
                <button class="btn btn-sm" :class="saved ? 'btn-secondary' : 'btn-primary'" @click="save" :disabled="saved"><i class="far fa-save me-1"></i>Save</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            opportunity: this.value ?? '',
            original: this.value ?? '',
        };
    },

    computed: {
        saved: function() {
            return this.opportunity == this.original;
        }
    },

    watch: {
        value: function(n, o) {
            this.opportunity = n ?? '';
            this.original = n ?? '';
        }
    },

    methods: {
        save: function() {
            if (this.opportunity) {
                this.$emit('input', this.opportunity);
            } else {
                this.$emit('remove');
            }
        }
    },
}
</script>